<div class="flex flex-col gap-1 w-full relative">
    <label class="flex items-center justify-between mb-1">
        <div class="text-sm font-normal text-gray-900 leading-none tracking-normal">{{lebal}} <span *ngIf="is_required" class="text-red-500">*</span></div>
        <span *ngIf="accept.includes('.csv') || accept.includes('.xlsx')" (click)="downloadTemplate()" class="text-[#3F41D1] font-medium text-sm leading-none tracking-normal cursor-pointer ml-2">Download Template</span>

    </label>

    <div class="flex flex-col gap-2">
        <!-- Box-style Photo Upload (Image only) -->
        <label *ngIf="uploaderVariant === 'photo-box' && (multiple || images.length === 0) && (accept?.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp'))" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" [class.border-[#3F41D1]]="isDragging" [class.bg-blue-50]="isDragging" class="flex flex-col items-center justify-center gap-2 px-4 py-6 bg-white border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-[#3F41D1] hover:bg-gray-50 transition-all duration-200">
            <input [disabled]="disabled || paramValue.view == 'true'" [accept]="accept" type="file" [multiple]="multiple" (change)="onImageSelected($event)" class="hidden" />
            <div class="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center text-[#3F41D1]">
                <i class='bx bx-image text-2xl'></i>
            </div>
            <div class="flex flex-col items-center gap-1">
                <span class="text-sm font-medium text-gray-700">Upload Photo</span>
                <span class="text-[0.65rem] text-gray-400">Click to select or drag & drop</span>
                <span class="text-[0.65rem] text-gray-400">(Supported: {{ accept }})</span>
            </div>
        </label>

        <!-- Minimal Upload Button -->
        <label *ngIf="uploaderVariant !== 'photo-box' && (multiple || images.length === 0)" class="flex items-center justify-start px-4 py-3 bg-white border border-gray-300 cursor-pointer hover:bg-gray-50 transition-all duration-200 group rounded-lg shadow-md">
            <input [disabled]="disabled || paramValue.view == 'true'" [accept]="accept" type="file" [multiple]="multiple" (change)="onImageSelected($event)" class="hidden" />
            <div class="flex flex-col items-center gap-1 text-gray-600]">
                <div class="flex items-center gap-2">
                    <!-- <i class='bx bx-cloud-upload text-xl'></i> -->
                    <img src="../../../assets/Upload_icon.svg" alt="">
                    <span class="text-sm font-medium">Choose {{ accept.includes('image') ? 'Image' : 'File' }} To Upload</span>
                    <span class="text-[0.65rem] text-gray-400">(Supported: {{ accept }}, Max: {{ maxFileSize }}MB)</span>
                </div>
            </div>
        </label>

        <!-- Photo Box Preview -->
        <div *ngIf="uploaderVariant === 'photo-box' && images.length > 0" class="grid grid-cols-1 gap-4 w-full">
            <div *ngFor="let img of images; let i = index" class="flex flex-col items-start gap-2 w-full">
                <div class="rounded-2xl bg-gray-100 overflow-hidden shadow-sm border border-gray-200 max-w-full" [ngClass]="photoBoxSizeClass">
                    <img *ngIf="accept?.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp')" [src]="img" class="w-full h-full object-cover">
                    <div *ngIf="!(accept?.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp'))" class="w-full h-full flex items-center justify-center">
                        <i class='bx bx-file text-gray-500 text-4xl'></i>
                    </div>
                </div>
                <p class="text-[0.65rem] text-gray-500">
                    ({{ accept.toUpperCase() }}, Max - {{ maxFileSize }}MB)
                </p>
                <div class="flex items-center gap-2">
                    <button type="button" (click)="view_image(i)" class="px-3 py-1 text-xs text-gray-600 border border-gray-300 rounded-full hover:text-primary hover:border-primary transition-colors">
                        View
                    </button>
                    <button *ngIf="!disabled && paramValue.view != 'true'" (click)="removeImage(i)" class="px-3 py-1 text-xs text-red-500 border border-red-200 rounded-full hover:bg-red-50 transition-colors">
                        Remove
                    </button>
                </div>
            </div>
        </div>

        <!-- Minimal File List -->
        <div *ngIf="uploaderVariant !== 'photo-box' && images.length > 0" class="flex flex-col gap-2">
            <div *ngFor="let img of images; let i = index" class="flex items-center justify-between py-1 p-4 bg-[#EBF2FF] border border-gray-200 rounded-lg shadow-md">
                <div class="flex items-center gap-3 overflow-hidden">
                    <!-- Preview Icon/Image -->

                    @if (accept?.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp')) {
                    <img (click)="view_image(i)" *ngIf="accept?.includes('image') || accept.includes('.jpg') || accept.includes('.png') || accept.includes('.jpeg') || accept.includes('.webp')" [src]="img" class="w-full h-full cursor-pointer object-cover">
                    }@else if(accept?.includes('pdf')) {
                    <img (click)="view_image(i)" class="cursor-pointer" src="../../../assets/PDF_File_Image.svg" alt="PDF File">
                    }@else {
                    <div (click)="view_image(i)" class="w-8 h-8 flex-shrink-0 rounded bg-gray-200 flex items-center justify-center overflow-hidden">
                        <i class='bx bx-file cursor-pointer text-gray-500 text-lg'></i>
                    </div>
                    }

                    <!-- File Info (Truncated) -->
                    <div class="flex flex-col min-w-0">
                        <span (click)="view_image(i)" class="text-sm font-medium cursor-pointer py-3 text-[#3F41D1] leading-none tracking-[0.02em] truncate block max-w-fit">
                            {{ (img?.split('/')?.pop()?.split('-')?.slice(1)?.join('-') || `Nova Mark ${lebal}` ) || 'Uploaded File ' + (i + 1) }}
                        </span>
                        <!-- <span class="text-[0.65rem] text-gray-500">
                            {{ imageSizes[i] || '' }}
                        </span> -->
                    </div>
                </div>

                <!-- Actions -->
                <div class="flex items-center gap-1">
                    <!-- <button type="button" (click)="view_image(i)" class="p-1 text-gray-400 hover:text-primary rounded-full hover:bg-blue-50 transition-colors">
                        <i class='bx bx-show text-lg'></i>
                    </button> -->
                    <!-- <button *ngIf="!disabled && paramValue.view != 'true'" (click)="removeImage(i)" class="p-1 text-gray-400 hover:text-red-500 rounded-full hover:bg-red-50 transition-colors">
                        <i class='bx bx-trash text-lg'></i>
                    </button> -->
                    <button *ngIf="!disabled && paramValue.view != 'true'" (click)="removeImage(i)" class="p-1 text-gray-400 rounded-full transition-colors">
                        <i class='bx bx-x text-red-500 text-2xl'></i>
                    </button>
                </div>
            </div>
        </div>
        <p class="text-xs text-gray-500 -mt-1 italic">{{ sub_text }}</p>
    </div>
</div>
<div *ngIf="control && control.errors && (control.dirty || control.touched)" class="mt-1">
    <p class="text-xs text-red-500" *ngIf="control.errors.required">{{lebal}} is required.</p>
</div>